<script setup lang="ts" generic="T extends object">
import type { ITableHeader } from "@/components/ui/Table/table.interface"
import { Card } from "@/components/ui"

interface DataCardProps {
  headers: ITableHeader<T>[]
  data: T
}

defineProps<DataCardProps>()
</script>

<template>
  <Card variant="offwhite">
    <dl class="flex flex-col gap-4">
      <div
        v-for="(column, columnIndex) in headers"
        :key="`cell-${columnIndex}`"
      >
        <template v-if="column">
          <dt class="text-[#333333] font-comfortaa font-bold whitespace-nowrap capitalize text-sm pb-1.5">
            <slot :name="`header-${String(column.value)}`">
              {{ column?.label ?? "—" }}
            </slot>
          </dt>
          <dd>
            <slot :name="`data-${String(column.value)}`" v-bind="{ data }">
              {{ column.value !== "actions" && column.value in data ? data[column.value]?.toString() : "—" }}
            </slot>
          </dd>
        </template>
      </div>
    </dl>
  </Card>
</template>
